<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Listado de balances" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-10">
			<LayoutTableMain :results="results" :loading="loading" @goPage="goPage">
				<template #filters>
					<div class="input-group input-group-sm rounded-pill">
						<span class="input-group-text bg-white rounded-start-pill pe-0" id="basic-addon1"><i class="bi bi-search"></i></span>
						<input type="text" v-model="filters.search" class="form-control border-start-0 rounded-end-pill" placeholder="Buscar..." />
					</div>
				</template>
				<template #body>
					<CompanyAdminBalanceTableRow v-for="data in results?.data" v-bind:key="data.id" :balance="data" @pay="pay" />
				</template>
			</LayoutTableMain>
		</main>

		<CompanyAdminBalancePayment ref="modalPayment" @reload="getResults" />
	</div>
</template>

<script>
	import { ref, reactive, watch, onMounted } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import composableForm from '@/composables/form';
	import CompanyAdminBalanceRepository from '@/repositories/modules/Company/Admin/Balance';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const results = ref({});
			const filters = reactive({
				search: null,
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminBalanceRepository.index(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const modalPayment = ref(null);
			const pay = (balance) => modalPayment.value.show(balance);

			const timeout = ref(null);
			watch(() => filters.search, () => {
				if(timeout.value) clearTimeout(timeout.value);
				timeout.value = setTimeout(() => goPage(1), 1000);
			});

			onMounted(getResults);

			return { loading, filters, results, getResults, goPage, modalPayment, pay };
		}
	}
</script>